import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { FibuFahrzeug } from './fibu-fahrzeug';
import { FibuFahrzeugDialogComponent } from './fibu-fahrzeug-dialog/fibu-fahrzeug-dialog.component';

@Component({
    selector: 'kiene-fahrzeuge',
    templateUrl: './fahrzeuge.component.html',
    styleUrls: ['./fahrzeuge.component.scss'],
})
export class FahrzeugeComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Fahrzeuge';
        this.tableDescriptor.uniqueIdentifier = 'FibuFahrzeuge';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fibu_fahrzeug/';
        this.tableDescriptor.route = '/finanzen/kontenrahmen/fahrzeuge/';
        this.tableDescriptor.nameOfIdField = 'fibu_fahrzeug_id';
        this.tableDescriptor.searchPlaceholder = 'Kennzeichen, Suffix oder Tierarzt suchen';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openDialog.bind(this);
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.showDetailsVoid = this.openDialog.bind(this);
        this.tableDescriptor.permissionView = 17010;
        this.tableDescriptor.permissionCreate = 17011;
        this.tableDescriptor.initialSortColumn = 'kennzeichen';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.columns = [
            new TableColumn('kennzeichen', 'Kennzeichen'),
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('kostenstelle_suffix', 'Haupt-Suffix'),
            new TableColumn('kostenarten_map', 'Suffixe je Kostenart'),
            new TableColumn('tierarzt', 'Tierarzt'),
            new KieneBooleanTableColumn('aktiv', 'Aktiv'),
            new TableColumn('modell', 'Modell'),
        ];

        this.tableDescriptor.options.push(
            new TableOption(this.openDialog.bind(this), 'Editieren', 'edit', 17011),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.confirmAndDelete.bind(this), 'Löschen', 'delete', 17012),
        );

        this.tableDescriptor.filterItems.push(
            new FilterItem('Aktiv', '1', FilterItemType.CHECKBOX, 'aktiv', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Inaktiv', '0', FilterItemType.CHECKBOX, 'aktiv', false),
        );
    }

    openDialog(fahrzeug?: FibuFahrzeug) {
        const dialogRef = this.dialog.open(FibuFahrzeugDialogComponent, {
            width: '720px',
            maxHeight: '90vh',
            data: { fahrzeug: fahrzeug ? { ...fahrzeug } : null },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    confirmAndDelete(fahrzeug: FibuFahrzeug) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: {
                title: 'Fahrzeug löschen',
                text: `Fahrzeug ${fahrzeug.kennzeichen} wirklich löschen?`,
            },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (!ok) {
                return;
            }
            this.api.deleteEntity(this.apiBaseUrl + 'fibu_fahrzeug/delete.php', fahrzeug).subscribe({
                next: () => {
                    this.messageService.infoMessage('Fahrzeug gelöscht.');
                    this.api.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Fahrzeug konnte nicht gelöscht werden.', err);
                    this.api.reload();
                },
            });
        });
    }
}
